import { useAppInsightsEvents } from '../analytics/appInsights/useAppInsightsEvents';
import { getAuthHeaders } from './getAuthHeaders';

/**
 * Used to make requests to APIs that require a specific scope.
 */
export const useScopedAPI = (scopeRequests: string[]) => {
	const { trackException } = useAppInsightsEvents();

	return {
		get: async <T>(url: string, params?: RequestInit): Promise<T> => {
			try {
				const headers = await getAuthHeaders(scopeRequests);

				const options: RequestInit = {
					method: 'GET',
					headers: headers,
					...(params || {}),
				};

				const apiResponse: Response = await fetch(url, options);
				return apiResponse.json();
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error('useScopedAPIs get Error', err);
				// @ts-expect-error
				trackException(err, { url });
				throw err;
			}
		},
		post: async <T>(url: string, body: string): Promise<T> => {
			try {
				const headers = await getAuthHeaders(scopeRequests);
				headers.append('Content-Type', 'application/json');

				const options = {
					method: 'POST',
					headers: headers,
					body,
				};

				const apiResponse: Response = await fetch(url, options);
				return apiResponse.json();
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error('useScopedAPIs post Error', err);
				// @ts-expect-error
				trackException(err, { url, body });
				throw err;
			}
		},
		delete: async (url: string): Promise<any> => {
			try {
				const headers = await getAuthHeaders(scopeRequests);
				headers.append('Accept', 'application/json');

				const options = {
					method: 'DELETE',
					headers: headers,
				};

				const apiResponse: Response = await fetch(url, options);
				return apiResponse.json();
			} catch (err) {
				// eslint-disable-next-line no-console
				console.error('useScopedAPIs post Error', err);
				// @ts-expect-error
				trackException(err, { url });
				throw err;
			}
		},
	};
};
